module.exports = __webpack_public_path__ + "static/media/inactivedelete.d5c16b3e.png";